import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: inherit;\n  color: inherit;\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  &:focus,\n  &:hover,\n  &:visited,\n  &:link,\n  &:active {\n    text-decoration: none;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: 5px 0px 0px 13.23px;\n  float: right;\n  display: block;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-self: center;\n  margin-right: auto;\n  position: absolute;\n  line-height: 22px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  border-bottom: 1px solid ", ";\n  color: ", ";\n  display: flex;\n  font-weight: 600;\n  font-size: 14px;\n  padding: 20px;\n  width: 100%;\n  max-height: 60px;\n  box-sizing: border-box;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  background-color: white;\n  box-shadow: ", ";\n  border-radius: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 20px;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import styled from '../utils/styling/styled-components';
import { Card } from '../Card';
export var Container = styled(Card)(_templateObject(), function (props) {
  return props.theme.shadows.lgLight;
}, function (props) {
  return props.theme.borderRadius.large;
});
var Eyebrow = styled.div(_templateObject2(), function (props) {
  return props.theme.colors.ivory;
}, function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.onClick && 'cursor: pointer;';
});
var LabelContainer = styled.div(_templateObject3());
var StyledChevron = styled(AcornsIcon)(_templateObject4());
var StyledLink = styled.div(_templateObject5());

var EyebrowContent = function EyebrowContent(_ref) {
  var showChevron = _ref.showChevron,
      content = _ref.content;
  return showChevron ? /*#__PURE__*/React.createElement(StyledLink, null, /*#__PURE__*/React.createElement(LabelContainer, null, content), /*#__PURE__*/React.createElement(StyledChevron, {
    icon: AcornsIcon.Icon.ChevronRight,
    width: "5px",
    height: "9px"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, content);
};

var CardWidget = function CardWidget(_ref2) {
  var children = _ref2.children,
      eyebrow = _ref2.eyebrow,
      testId = _ref2.testId,
      handleClick = _ref2.handleClick,
      showChevron = _ref2.showChevron,
      className = _ref2.className;
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    "data-testid": testId
  }, eyebrow && /*#__PURE__*/React.createElement(Eyebrow, {
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(EyebrowContent, {
    showChevron: showChevron,
    content: eyebrow
  })), children);
};

export { CardWidget };